import React, { useEffect, useState } from 'react';

const TimeAgo = ({ timestamp }) => {
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    const updateTimeAgo = () => {
      const currentTime = new Date();
      const editedTime = new Date(timestamp);

      const timeDifference = currentTime - editedTime;

      if (timeDifference < 60000) {
        setTimeAgo('Last edited just now');
      } else if (timeDifference < 3600000) {
        const minutesAgo = Math.floor(timeDifference / 60000);
        setTimeAgo(`Last edited ${minutesAgo}min ago`);
      } else if (timeDifference < 86400000) {
        const hoursAgo = Math.floor(timeDifference / 3600000);
        setTimeAgo(`Last edited ${hoursAgo}h ago`);
      } else if (timeDifference < 2592000000) {
        const daysAgo = Math.floor(timeDifference / 86400000);
        setTimeAgo(`Last edited ${daysAgo}d ago`);
      } else {
        const monthsAgo = Math.floor(timeDifference / 2592000000);
        setTimeAgo(`Last edited ${monthsAgo}month ago`);
      }
    };

    updateTimeAgo();

    // Update the time ago text every minute to keep it up to date
    const interval = setInterval(updateTimeAgo, 60000);

    return () => clearInterval(interval);
  }, [timestamp]);

  return <span>{timeAgo}</span>;
};

export default TimeAgo;
